import React from 'react';
import { Box } from '@wix/design-system';
export function NarrowAppBox({ appName = null, appIcon = null, appTeaser = null, companyName = null, topBadge = null, ctaButton = null, reviewsInfo = null, bottomBadge = null, className, }) {
    return (React.createElement(Box, { className: className, width: "100%", height: "100%", direction: "vertical", align: "space-between" },
        React.createElement(Box, { direction: "vertical" },
            React.createElement(Box, { marginBottom: "6px", align: "space-between" },
                appIcon,
                topBadge),
            React.createElement(Box, { direction: "vertical" },
                React.createElement(Box, { direction: "vertical" },
                    appName,
                    companyName),
                React.createElement(Box, { marginTop: "6px", marginBottom: "24px" }, appTeaser))),
        React.createElement(Box, { align: "space-between", verticalAlign: ctaButton ? 'bottom' : 'middle' },
            React.createElement(Box, { direction: "vertical", gap: "6px" },
                ctaButton ? reviewsInfo : null,
                bottomBadge),
            ctaButton ?? reviewsInfo)));
}
//# sourceMappingURL=narrow-app-box.js.map